import React from 'react';
import ReactDOM from 'react-dom';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup';
import TouchButton from '../../components/TouchButton';
import ReactFireMixin from 'reactfire';
import {firebaseRoot, snapshotToDeepArray} from '../../utils/firebase-utils';
import objectAssign from 'object-assign';
import 'filepicker-js';

const Import = React.createClass({
    mixins: [ReactFireMixin],

    getInitialState() {
        return {spec: {}, logs: []};
    },

    pickType(type) {
        this.setState(objectAssign({}, this.state.spec, {type: type}));
        this.specRef.update({type: type}).then(
            null, window.alert
        );
    },

    rebind(props) {
        this.queueRef = firebaseRoot.child('admin/queue/tasks');
        const importRef = firebaseRoot.child('admin/imports').child(props.params.importId);
        this.specRef = importRef.child('spec');
        this.bindAsObject(this.specRef, 'spec');
        this.bindAsArray(importRef.child('logs'), 'logs')
    },

    componentWillMount() {
        this.rebind(this.props);
    },

    componentPropsWillChange(newProps) {
        this.rebind(newProps);
    },

    linkState(name) {
        return {
            value: this.state.spec[name],
            requestChange: (newValue) => {
                this.setState(objectAssign({}, this.state.spec, {[name]: newValue}));
                this.specRef.update({[name]: newValue}).then(
                    null, window.alert
                );
            }
        }
    },

    go() {
        this.queueRef.push({type: 'run_import', key: `/admin/imports/${this.props.params.importId}`})
    },

    render() {
        const TypeButton = ({type, name}) =>
            <TouchButton onClick={this.pickType.bind(this, type)} active={this.state.spec.type == type}>{name}</TouchButton>;

        return <div>
            <textarea rows="20" cols="120" valueLink={this.linkState('data')} />

            <br/><br/><br/>

            Pick a sheet type to import
            <ButtonToolbar>
                <ButtonGroup>
                    <TypeButton type="isbn" name="ISBN"/>
                    <TypeButton type="exercise-base" name="Exercise base"/>
                    <TypeButton type="exercise-step" name="Exercise step"/>
                    <TypeButton type="lessons" name="Lessons"/>
                    <TypeButton type="schools" name="Schools"/>
                </ButtonGroup>
            </ButtonToolbar>

            <br/><br/><br/>

            {this.state.spec.type &&
            <ButtonToolbar>
                <ButtonGroup>
                    <TouchButton onClick={this.go}>Go!</TouchButton>
                </ButtonGroup>
            </ButtonToolbar>}

            <div>
                <h4>Log output:</h4>
                <pre style={{height: '100%', overflow: 'auto'}}>
                    {this.state.logs.map(log => log['.value'] + '\n')}
                </pre>
            </div>
        </div>;
    }
});

export default Import;


/** WEBPACK FOOTER **
 ** ./src/admin/screens/Import.js
 **/